import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { Page404Component } from './extrapages/page404/page404.component';
import { SEO } from './core/seo/seo-paginas';

const appChildren: Routes = [
  { path: 'noticias', loadChildren: () => import('./pages/extrapages/noticias.module').then(m => m.NoticiasModule) },
  { path: 'auth', loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule) },
  { path: '', loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule) },
  { path: 'pages', loadChildren: () => import('./extrapages/extrapages.module').then(m => m.ExtrapagesModule) },
  {
    path: '**',
    component: Page404Component,
    data: { seo: SEO.page404 },
  },
];

const routes: Routes = [
  { path: 'en', children: appChildren },
  ...appChildren,
];

const routerOptions: ExtraOptions = {
  anchorScrolling: 'enabled',
  scrollPositionRestoration: 'enabled',
};

@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
